import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap"
import PrimaryButton from "newcomponents/primary-button"
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined"

const DeleteConfirmationModal = ({
  isOpen,
  toggle,
  mode = "light",
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item?",
  subMessage = "",
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  icon: IconComponent = DeleteOutlineOutlinedIcon,
  iconColor,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      style={{ maxWidth: "500px" }}
    >
      <div
        style={{
          backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
          borderRadius: "12px",
          padding: "0",
        }}
      >
        <ModalHeader
          toggle={toggle}
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            color: mode === "dark" ? "#fff" : "#000",
            fontWeight: "600",
            fontSize: "18px",
            borderBottom:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
            paddingBottom: "16px",
          }}
        >
          {title}
        </ModalHeader>

        <ModalBody
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            textAlign: "center",
            padding: "30px 40px",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
            }}
          >
            <IconComponent
              style={{
                fontSize: "80px",
                color: iconColor || (mode === "dark" ? "#EF4444" : "#EF4444"),
              }}
            />
          </div>
          <h5
            style={{
              color: mode === "dark" ? "#fff" : "#000",
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            {message}
          </h5>
          {subMessage && (
            <p
              style={{
                color: mode === "dark" ? "#9ca3af" : "#666",
                fontSize: "12px",
                marginBottom: "0",
              }}
            >
              {subMessage}
            </p>
          )}
        </ModalBody>

        <ModalFooter
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            justifyContent: "center",
            gap: "12px",
            borderTop:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
          }}
        >
          <PrimaryButton
            onClick={onCancel || toggle}
            style={{
              backgroundColor: "white",
              border:
                mode === "dark" ? "1px solid #374151" : "1px solid #e0e0e0",
              color: "#000",
              fontSize: "14px",
              fontWeight: "500",
              width: "166px",
              height: "46px",
              minWidth: "120px",
              borderRadius: "5px",
            }}
          >
            {cancelText}
          </PrimaryButton>

          <PrimaryButton
            onClick={onConfirm}
            disabled={loading}
            style={{
              backgroundColor: "#EF4444",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              width: "166px",
              height: "46px",
              minWidth: "120px",
              borderRadius: "5px",
            }}
          >
            {loading ? <Spinner size="sm" /> : confirmText}
          </PrimaryButton>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default DeleteConfirmationModal
